var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"py-1 px-2",attrs:{"color":"medium-grey"}},[_c('div',{staticClass:"container flex justify-end px-4 2xl:px-0"},[_c('pre',{staticClass:"text-xs tracking-tighter text-gray-300"},[_vm._v("HUB cuprolli v."+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }